import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { isEmpty } from "@/utils/Common";
import { showWarning } from "@/utils/UI";
import { useStore } from "@/stores";
import router from "@/router";

// eslint-disable-next-line @typescript-eslint/no-var-requires

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props) {

const loginBg = require("@/assets/login-bg.webp");

const store = useStore();

const username = ref("");
const password = ref("");
const isLogging = ref(false);
const appTitle = computed(() => store.getters.appTitle);

const doLogin = async () => {
  if (isEmpty(username.value)) {
    showWarning("请输入用户名");
    return;
  }
  if (isEmpty(password.value)) {
    showWarning("请输入密码");
    return;
  }

  const postedData = {
    loginType: "LOGIN_NAME",
    loginName: username.value,
    password: password.value,
  };
  try {
    isLogging.value = true;
    await store.dispatch("user/login", postedData);
    const user = store.getters["user/user"];
    if (!user) {
      return;
    }
    if (user.id === 4) {
      await router.push({ name: "patent-list", params: { projectId: "1098149854838784" } });
    } else {
      await router.push("index");
    }
  } finally {
    isLogging.value = false;
  }
};

return { __sfc: true,loginBg, store, username, password, isLogging, appTitle, doLogin }
}

})